import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=8cb9de4c&scoped=true"
import script from "./inspect.vue?vue&type=script&lang=js"
export * from "./inspect.vue?vue&type=script&lang=js"
import style0 from "./inspect.vue?vue&type=style&index=0&id=8cb9de4c&prod&lang=less"
import style1 from "./inspect.vue?vue&type=style&index=1&id=8cb9de4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb9de4c",
  null
  
)

export default component.exports